import DOMPurify from 'dompurify'

export const useDompurify = () => {
  /**
   * 过滤v-html显示的内容
   */
  const clean = (html: string): string => DOMPurify.sanitize(html)

  /**
   * 过滤input输入的HTML标签内容
   */
  const filterHTML = (input: string): string =>
    input ? input.replace(/<[^>]*>/g, '') : ''

  return { clean, filterHTML }
}
